import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import { faTag, faClock } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import {
  StyledProductImageContainer,
  StyledProductImage,
  StyledProductTime,
  StyledBidButton,
  StyledSubheading,
  StyledProductHeading,
  StyledFaTag,
  StyledPaddingContainer,
  StyledPrice,
  StyledInfoContainer,
  StyledStartingPrice,
  StyledBox,
  StyledShadowContainer,
  StyledRapnetContainer,
  StyledArrowButton,
} from "./StyledComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getImageSource, toggleLoginPopup } from "../Utils";
import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { useDialog } from "../../../common/elements/Dialog/Dialog";
import { SignIn } from "../Header/SignIn";
import Colors from "../../../common/materials/colors";
import Cross from "../Static/Icons/Cross";
import Button from "../../../common/elements/Button";
import { LandingPagePlayFairFont } from "../StyledComponents";
import { setParticipateProductId } from "../../../redux/slice/commanPagination/commanPaginationSlice";
import ArrowButton from "../Static/Icons/ArrowButton";
import { ParcelType } from "../../../enums/productEnum";
import { MobileSignIn } from "../../zipang/Header/ZipangHeader";
import Countdown from "react-countdown";
import moment from "moment";
import { removeHttpsLink } from "../../../common/GenericFunctions";
import ThumbnailImage from "../../../components/videoPlayer/ThumbnailImage";
import { useHistory } from "react-router";
import { oAuth } from "../../../routes/basic/BasicAppRouter";

interface IProductCardProps {
  id: string;
  auctionStartDate: string;
  exchangeRates: any;
  auctionName: string;
  productStartDate: string;
  productEndDate: string;
  annualProductState: string;
  carat: string;
  color: string;
  clarity: string;
  lab: string;
  cutGrade: string;
  flour: string;
  polish: string;
  symmetryAbbreviation: string;
  shape: null | string;
  sieve: null | string;
  code: string;
  parcelType: string;
  medias: Array<{ mediaType: string; presignedUrl: string }>;
  buttonText: string;
  caratMinimumPrice: number;
  startingPrice: number;
  rapnetPercentage: number;
  rapnetPrice: number;
  currentBidPrice: number;
  time: string;
  jewelleryDetails: {
    jewelleryCondition: string;
    jewelleryDescription: string;
    jewelleryType: string;
  };
  currency: {
    code: string;
    symbol: string;
  };
  redacted?: boolean;
  auctionType: string;
  buyItNow: number;
  remarks: null | string;
}

const faTagProps = faTag as IconProp;
const faClockProps = faClock as IconProp;

const getProductDescription = (
  t: (arg0: string) => any,
  lab: string,
  carat: string,
  color: string,
  clarity: string,
  cutGrade: string,
  flour: string,
  polish: string,
  symmetry: string,
  shape: null | string,
  sieve: null | string,
  parcelType: string,
  product_description: string
) => {
  const CARAT: any =
    carat === undefined ? "" : `${carat} ${t("common:preview:ct")}`;
  const COLOR: any = color === undefined ? "" : color;
  const LAB: any = lab === undefined ? "" : lab;
  const CLARITY: any = clarity === undefined ? "" : clarity;
  const CUTGRADE: any = cutGrade === undefined ? "" : cutGrade;
  const FLOUR: any = flour === undefined ? "" : flour;
  const POLISH: any =
    polish === undefined ? "" : `${t("common:preview:pol")}=${polish}`;
  const SYMMETRY_ABBREVATION: any =
    symmetry === undefined ? "" : `${t("common:preview:sym")}=${symmetry}`;
  const PRODUCT_SHAPE: any = shape === undefined || shape === null ? "" : shape;
  const PRODUCT_SIEVE: any = sieve === undefined || sieve === null ? "" : sieve;
  let parcelDesc = parcelType === "Parcel" ? product_description : "";

  return [
    LAB,
    CARAT,
    COLOR,
    PRODUCT_SHAPE,
    PRODUCT_SIEVE,
    CLARITY,
    CUTGRADE,
    FLOUR,
    POLISH,
    SYMMETRY_ABBREVATION,
    parcelDesc,
  ].reduce((acc, type) => (type ? acc + `${type} ` : acc), "");
};

const getJewellaryDesc = (details: {
  jewelleryCondition: string;
  jewelleryDescription: string;
  jewelleryType: string;
}) => {
  return `${details.jewelleryDescription} ${details.jewelleryCondition} ${details.jewelleryType}`;
};

const useStyles = makeStyles({
  container: {
    padding: "2em 1em",
    background: Colors.grey1,
    position: "relative",
  },
  cross: {
    position: "absolute",
    right: "1em",
    top: "1em",
    margin: 0,
  },
});

const getAmountToBeShown = (
  caratMinimumPrice: number,
  currency: any,
  exchangeRates: any
) => {
  let caratMinPrice = new Intl.NumberFormat("us-en").format(caratMinimumPrice);
  let amountToBeShown = "";
  if (
    caratMinimumPrice === null ||
    caratMinPrice === "NaN" ||
    caratMinPrice === "0"
  ) {
    caratMinPrice = "-";
  } else {
    let conversionPriceS = new Intl.NumberFormat("us-en").format(
      Math.round(caratMinimumPrice * exchangeRates[0]["rate"])
    );

    caratMinPrice = `${currency["symbol"]}${caratMinPrice}`;

    if (currency["code"] === "USD") {
      amountToBeShown = `¥${conversionPriceS} (${caratMinPrice})`;
    } else {
      amountToBeShown = `${caratMinPrice} ($${conversionPriceS})`;
    }
    return amountToBeShown;
  }
};

var urlRegex = /(https?:\/\/[^\s]+)/g;

const AnnualProductCard = ({
  id,
  auctionStartDate,
  fixedHeightCards = false,
  exchangeRates,
  currentBidPrice,
  auctionName,
  parcelType,
  medias,
  code,
  buttonText,
  caratMinimumPrice,
  startingPrice,
  rapnetPercentage,
  rapnetPrice,
  time,
  currency,
  lab,
  carat,
  color,
  clarity,
  cutGrade,
  flour,
  polish,
  sieve,
  symmetry,
  symmetryAbbreviation,
  shape,
  jewelleryDetails,
  buyItNow,
  auctionType,
  hideBidButton = false,
  redacted = false,
  isZipang,
  productEndDate,
  productStartDate,
  annualProductState,
  isLandingPage,
  remarks,
  carouselMode = false,
}: IProductCardProps & {
  fixedHeightCards?: boolean;
  hideBidButton?: boolean;
  isZipang: boolean;
  isLandingPage: boolean;
  carouselMode?: boolean;
  symmetry?: any;
}) => {
  const history = useHistory();
  const getMediasForCarosuel = () => {
    const mediaslist: any = medias;
    for (let i = 0; i < mediaslist.length; i++) {
      let mediaItem = mediaslist[i];
      if (
        mediaItem?.mediaType === "PHOTO" ||
        mediaItem?.mediaType === "VIDEO"
      ) {
        if (mediaItem?.primary === true) {
          mediaslist.splice(i, 1);
          mediaslist.unshift(mediaItem);
          break;
        }
      }
    }
    return mediaslist;
  };
  const img = getImageSource(getMediasForCarosuel());
  // console.log(img);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const numFor = Intl.NumberFormat("en-US");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isParcelTypeDiamond = () => {
    return parcelType === ParcelType.DIAMOND;
  };
  const isParcelTypeJewellery = () => {
    return parcelType === ParcelType.JEWELLERY;
  };
  const [createDialog, closeDiage] = useDialog();
  const classes = useStyles();

  const [mouseOver, setMouseOver] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);

  let seconds: any = "";

  const handleMobileSignIn = () => {
    createDialog({
      children: (
        <div className={classes.container}>
          <Button
            type=""
            onClick={closeDiage}
            className={classes.cross}
            noMargin
          >
            <Cross filled />
          </Button>
          <p>
            <Typography variant="h4" align="center">
              <LandingPagePlayFairFont>
                {t("common:signIntoYourAcc")}
              </LandingPagePlayFairFont>
            </Typography>
          </p>
          <SignIn handleClose={closeDiage} />
        </div>
      ),
      fullWidth: true,
      open: true,
    });
  };

  const handleBidClick = () => {
    if (hideBidButton) return;
    dispatch(setParticipateProductId({ id: code }));
    // if (isMobile) {
    //   if (isZipang) {
    //     setShowSignIn(true);
    //   } else {
    //     handleMobileSignIn();
    //   }
    // } else {
    // toggleLoginPopup();
    //  const categoryType= category === "Jewellery" ? "/jewelleyProducts" : "";
    const categoryType = "";
    if (oAuth() === false) {
      history.push(
        `../../../product${categoryType}/${id}/${auctionStartDate}/detail`
      );
    }
    // }
  };

  const amountToBeShown = getAmountToBeShown(
    currentBidPrice,
    currency,
    exchangeRates
  );

  const buyItNowAmountToBeShown = getAmountToBeShown(
    buyItNow,
    currency,
    exchangeRates
  );

  const carratMinToBeShown = getAmountToBeShown(
    caratMinimumPrice,
    currency,
    exchangeRates
  );

  var urls = remarks ?? "".match(urlRegex);

  const newString: any = removeHttpsLink(remarks);

  let product_description: string =
    remarks === undefined || remarks === null ? "" : urls ? newString : "";

  const descriptionText =
    parcelType === "Diamond" || parcelType === "Parcel"
      ? getProductDescription(
          t,
          lab,
          carat,
          color,
          clarity,
          cutGrade,
          flour,
          polish,
          symmetry,
          shape,
          sieve,
          parcelType,
          product_description
        )
      : parcelType === "Jewellery"
      ? getJewellaryDesc(jewelleryDetails)
      : null;

  const handleMouseOver = () => {
    setMouseOver(!mouseOver);
  };

  const handleSignUpModal = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    const hiddenButton = document.getElementById("hiddenButton");
    if (!hiddenButton) return;
    hiddenButton.click();
  };

  const getRapnetPercentage = () => {
    if (!rapnetPercentage) {
      return "-";
    }
    if (rapnetPercentage == 0 || rapnetPercentage == 0.0) {
      return "-";
    }
    try {
      let amount: number;
      const rate = exchangeRates?.[0]?.["rate"] ?? 1;
      if (currency.code === "JPY") {
        amount = (currentBidPrice || caratMinimumPrice) * rate;
      } else {
        amount = currentBidPrice || caratMinimumPrice;
      }

      const price = 1 - amount / rapnetPrice || 0;
      const firstTwoNumbers = price * -100;
      const fixed = firstTwoNumbers.toFixed(2);
      return fixed;
    } catch (e) {
      return "-";
    }
  };

  const getBuyItNowRapnetPercentage = () => {
    if (!rapnetPercentage) {
      return "-";
    }
    if (buyItNow === undefined) {
      return "-";
    }
    try {
      let amount: number;
      const rate = exchangeRates?.[0]?.["rate"] ?? 1;
      if (currency.code === "JPY") {
        amount = buyItNow * rate;
      } else {
        amount = buyItNow;
      }

      const price = 1 - amount / rapnetPrice || 0;
      const firstTwoNumbers = price * -100;
      const fixed = firstTwoNumbers.toFixed(2);
      return fixed;
    } catch (e) {
      return "-";
    }
  };

  const productTimeLeft = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, "Asia/Kolkata");
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          let end: any = moment(dateTime);
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
          );
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
        }
      }
    }
    return (
      <Countdown
        date={Date.now() + seconds}
        className="countdownText"
        renderer={renderer}
        zeroPadTime={2}
      />
    );
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const Wrapper = carouselMode ? Box : Grid;

  return (
    <Wrapper
      {...(!carouselMode && {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        lg: isLandingPage ? 4 : 3,
        xl: isLandingPage ? 4 : 3,
      })}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOver}
      style={{
        width: carouselMode ? "100%" : isMobile ? "80vw" : "auto",
        /* background: isLandingPage ? "#1433e2ff" : "#99c00dff", */
      }}
    >
      <StyledShadowContainer
        style={{
          height: isLandingPage ? "540px" : "560px",
        }}
      >
        <StyledProductImageContainer onClick={handleBidClick}>
          {redacted ? (
            <Skeleton
              variant="rectangular"
              animation="wave"
              height={"100%"}
              width={"100%"}
            />
          ) : (
            <>
              {img === undefined ? (
                <StyledProductImage
                  loading="lazy"
                  src={`/images/${
                    isParcelTypeDiamond() || isParcelTypeJewellery()
                      ? "default-diamond.png"
                      : "default-parcel.png"
                  }`}
                ></StyledProductImage>
              ) : img.mediaType === "VIDEO" ? (
                <ThumbnailImage thumbnail={img.thumbnailPresignedUrl} />
              ) : (
                <StyledProductImage
                  loading="lazy"
                  src={img?.thumbnailPresignedUrl}
                ></StyledProductImage>
              )}
            </>
          )}
          {time && (
            <StyledProductTime>
              <FontAwesomeIcon icon={faClockProps} />
              &nbsp;
              {time}
            </StyledProductTime>
          )}
          {hideBidButton ? (
            (mouseOver || isMobile) && (
              <StyledArrowButton>
                <ArrowButton onClick={handleSignUpModal} />
              </StyledArrowButton>
            )
          ) : (
            <StyledBidButton
              // onClick={handleBidClick}
              type={isZipang ? "contained-dark-Red" : "contained-dark"}
              noMargin
            >
              {auctionType === "Annual" ? (
                <>{t("common:buyNow")}</>
              ) : (
                <>{t("common:bid")}</>
              )}
            </StyledBidButton>
          )}
        </StyledProductImageContainer>
        <StyledPaddingContainer>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <StyledSubheading>
              {redacted ? (
                <Skeleton variant="rectangular" animation="wave" />
              ) : (
                code
              )}
            </StyledSubheading>

            {auctionType === "Annual" && (
              <StyledSubheading>
                {redacted ? (
                  <Skeleton variant="rectangular" animation="wave" />
                ) : (
                  <>
                    {annualProductState === "Started" ? (
                      <span style={{ color: "red" }}>
                        <strong>
                          {t("common:endsin")} {productTimeLeft(productEndDate)}
                        </strong>
                      </span>
                    ) : (
                      <span style={{ color: "green" }}>
                        <strong>
                          {t("common:startsin")}{" "}
                          {productTimeLeft(productStartDate)}
                        </strong>
                      </span>
                    )}
                  </>
                )}
              </StyledSubheading>
            )}
          </Box>
          <StyledProductHeading>
            {redacted ? (
              <Skeleton variant="rectangular" animation="wave" />
            ) : (
              <strong title={descriptionText}>{descriptionText}</strong>
            )}
          </StyledProductHeading>
          <StyledBox
            display="flex"
            justifyContent="space-between"
            alignContent="space-between"
          >
            <StyledInfoContainer>
              <StyledBox
                display="flex"
                justifyContent="space-between"
                alignContent="center"
              >
                <Box display="flex">
                  {redacted ? (
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      width={20}
                    ></Skeleton>
                  ) : (
                    <StyledFaTag
                      icon={faTagProps}
                      style={{ color: isZipang ? "#d92b3c" : "#4f96e2" }}
                    />
                  )}
                  <div>
                    {redacted ? (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={20}
                      ></Skeleton>
                    ) : (
                      (caratMinimumPrice || currentBidPrice) && (
                        <StyledPrice fixedHeight={fixedHeightCards}>
                          {currentBidPrice
                            ? amountToBeShown
                            : carratMinToBeShown}
                        </StyledPrice>
                      )
                    )}
                    {!redacted && caratMinimumPrice && (
                      <StyledStartingPrice>
                        <span>
                          &nbsp;
                          <strong>
                            {t("common:preview:productsList:startingPrice")}
                          </strong>
                          &nbsp;
                          <span>
                            {currency.symbol}
                            {numFor.format(caratMinimumPrice)}
                          </span>
                        </span>
                      </StyledStartingPrice>
                    )}
                  </div>
                </Box>
                {!redacted && rapnetPercentage !== undefined && (
                  <StyledRapnetContainer>
                    <StyledStartingPrice>
                      <strong>{t("common:preview:productsList:ro")}</strong>
                    </StyledStartingPrice>
                    {getRapnetPercentage()}
                  </StyledRapnetContainer>
                )}
                {!rapnetPercentage && redacted && (
                  <Skeleton
                    variant="rectangular"
                    animation="wave"
                    width={40}
                  ></Skeleton>
                )}
              </StyledBox>

              {auctionType === "Annual" && (
                <StyledBox
                  display="flex"
                  justifyContent="space-between"
                  alignContent="center"
                  style={{ marginTop: "5px" }}
                >
                  <Box display="flex">
                    {redacted ? (
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={20}
                      ></Skeleton>
                    ) : (
                      <StyledFaTag
                        icon={faTagProps}
                        style={{ color: isZipang ? "#d92b3c" : "#4f96e2" }}
                      />
                    )}
                    <div>
                      {redacted ? (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={20}
                        ></Skeleton>
                      ) : (
                        (buyItNow || caratMinimumPrice) && (
                          <StyledPrice fixedHeight={fixedHeightCards}>
                            {buyItNowAmountToBeShown}
                          </StyledPrice>
                        )
                      )}
                      {!redacted && buyItNow ? (
                        <StyledStartingPrice>
                          <span>
                            &nbsp;
                            <strong>{t("common:buyItNowPrice")}</strong>
                            &nbsp;
                            <span>
                              {currency.symbol}
                              {numFor.format(buyItNow)}
                            </span>
                          </span>
                        </StyledStartingPrice>
                      ) : (
                        <StyledStartingPrice>
                          <StyledStartingPrice>
                            <strong>{t("common:buyItNowPrice")}</strong>
                          </StyledStartingPrice>
                          <span>
                            <span>-</span>
                          </span>
                        </StyledStartingPrice>
                      )}
                    </div>
                  </Box>
                  {!redacted && rapnetPercentage !== undefined && (
                    <StyledRapnetContainer>
                      <StyledStartingPrice>
                        <strong>{t("common:preview:productsList:ro")}</strong>
                      </StyledStartingPrice>
                      {getBuyItNowRapnetPercentage()}
                    </StyledRapnetContainer>
                  )}
                  {!rapnetPercentage && redacted && (
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      width={40}
                    ></Skeleton>
                  )}
                </StyledBox>
              )}
            </StyledInfoContainer>
          </StyledBox>
        </StyledPaddingContainer>
      </StyledShadowContainer>
      <MobileSignIn show={showSignIn} onClose={() => setShowSignIn(false)} />
    </Wrapper>
  );
};

export default React.memo(AnnualProductCard);
